import http from './httpService';
import config from '../configs/config.js';
import references from '../configs/reference.json';
import masking from '../configs/masking.json';
import { largeDate, monthYear } from '../utils/constants';
import qs from 'qs';

const apiEndPoint = config.apiEndPoint + '/anomaly';
const trendEndPoint = config.apiEndPoint + '/trend';
const networkEndPoint = config.apiEndPoint + '/networkgraph';
const predictiveTrendEndPoint = config.apiEndPoint + '/predictive_trend';
const chatPoint=config.apiEndPoint+'/chathistory'
const recoPoint=config.apiEndPoint+'/recommendation'
function generateURL(path) {
  return `${apiEndPoint}/${path}`;
}

export async function getSummaryAlertRc(id) {
  const params = { id: id };
  const rcs = await http.get(generateURL('summary-rc'), {
    params: params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });
  references.forEach(function (val) {
    rcs.data.forEach(function (data, i) {
      data.inference = data.inference.replaceAll(val.from, val.to);
    });
  });
  return rcs;
}

//1. card API
export async function getSummaryAnomalyList(level) {
  let anomalies = await http.get(generateURL('summary'), {
    params: { level: level }
  });
  anomalies.data.forEach(function (data) {
    data.kpi_name = data.aan_name;
    data.aan_value_new = data.aan_value;
    data.aan_month = new Date(data.aan_date).toLocaleString(
      undefined,
      monthYear
    );
  });
  references.forEach(function (val) {
    anomalies.data.forEach(function (data, i) {
      if (val.from === data.kpi_name) {
        data.kpi_direction = val.direction;
        data.kpi_format = val.format;
      }
      data.kpi_name = data.kpi_name.replaceAll(val.from, val.to);
      data.inference = data.inference.replaceAll(val.from, val.to);
    });
  });
 
  return anomalies;
}

//1. card API
export async function getAnomalyList() {
  let anomalies = await http.get(apiEndPoint);
  anomalies.data.forEach(function (data) {
    data.kpi_name = data.aan_name;
    data.aan_value_new = data.aan_value;
    data.aan_month = new Date(data.aan_date).toLocaleString(
      undefined,
      monthYear
    );
  });
  references.forEach(function (val) {
    
    anomalies.data.forEach(function (data, i) {
      
      if (val.from === data.kpi_name) {
        
        data.kpi_direction = val.direction;
        data.kpi_format = val.format;
      }
      data.aan_level = data.aan_level.replaceAll(val.from, val.to);
      data.kpi_name = data.kpi_name.replaceAll(val.from, val.to);
      data.inference = data.inference.replaceAll(val.from, val.to);
    });
  });
  
  /* remove below code if there is no masking */
  /* Also change aan_value_new to aan_value in below files */
  /* anomaly.jsx - Line 21 */
  /* filterPane.jsx - Line 32 & 82 */
  masking.forEach(function (val) {
    anomalies.data.forEach(function (data, i) {
      data.kpi_name = data.kpi_name.replaceAll(val.from, val.to);
      data.inference = data.inference.replaceAll(val.from, val.to);
    });
  });

  return anomalies;
}

//2. Tile API
export async function getAnomalyByID(id) {
  let anomaly = await http.get(generateURL(id));
  anomaly.data.kpi_name = anomaly.data.aan_name;
  //converting date from UTC to IST
  let last_upd = new Date(anomaly.data.last_updated + 'Z');
  anomaly.data.last_updated = last_upd.toLocaleString(undefined, largeDate);
  //rename kpi name
  references.forEach(function (val) {
    if (val.from === anomaly.data.kpi_name) {
      anomaly.data.kpi_direction = val.direction;
      anomaly.data.kpi_format = val.format;
    }
    anomaly.data.kpi_name = anomaly.data.kpi_name.replaceAll(val.from, val.to);
    anomaly.data.inference = anomaly.data.inference.replaceAll(
      val.from,
      val.to
    );
  });
  /* remove below code if there is no masking */
  masking.forEach(function (val) {
    anomaly.data.inference = anomaly.data.inference.replaceAll(
      val.from,
      val.to
    );
  });
 
  return anomaly;
}

//3. Status Update API
export async function anomalyStatusUpdate(id, status) {
  const body = { status: status };
  let anomaly = await http.put(generateURL(id), body);
  //console.log('Status Update API', anomaly);
  return anomaly;
}
export async function getButtonNames() {
  let reco = await http.get(recoPoint);

  return reco;
}
export async function getAlertTrendData(aan_date,aan_name,aan_level,aan_value){

  let anomaly = await http.get(apiEndPoint+'/trends',
  {
    params: {aan_date:aan_date,aan_name:aan_name,aan_level: aan_level,aan_value:aan_value }
  });

    return anomaly
}
//4. Line API
export async function getTrendData(anomaly, type = 'rca', predictive = false) {
  let query = trendEndPoint;
  let data = await http.get(query, {
    params: {
      alert_id: anomaly.anomaly_id,
      rca_id:
        Object.keys(anomaly).includes('rca_id') && type === 'rca'
          ? anomaly.rca_id
          : ''
    }
  });
  let { data: predictive_data } =
    anomaly.anomaly_type === 'predictive' || predictive
      ? await http.get(predictiveTrendEndPoint, {
          params: {
            alert_id: anomaly.anomaly_id,
            rca_id:
              Object.keys(anomaly).includes('rca_id') && type === 'rca'
                ? anomaly.rca_id
                : ''
          }
        })
      : { data: [] };
  const temp_data = { ...data };
  temp_data.data = [...predictive_data, ...data.data];
  temp_data.count = predictive_data.length;
  // console.log('Trend API', temp_data);
  return temp_data;
}

//5. Stacked Bar API
export async function getStackedBar() {
  let data = await http.get(generateURL('severity'));
  //console.log('Stacked Bar API', data);
  return data;
}

//6. Get RCAs by anomaly id
export async function getRCA(id) {
  let rcas = await http.get(generateURL('rca/' + id));
  rcas.data.forEach(function (data) {
    data.aan_kpi_name = data.aan_name;
    data.kpi_name = data.rc_name;
    data.aan_level_new=data.aan_level;
    data.rc_kpi_name = data.rc_name;
    data.rc_value_new = data.rc_value;
    data.aan_value_new = data.aan_value;
  });
  references.forEach(function (val) {
    rcas.data.forEach(function (data, i) {
      if (val.from === data.rc_name) {
        data.rc_direction = val.direction;
        data.rc_format = val.format;
      }
      if (val.from === data.aan_name) {
        data.aan_direction = val.direction;
        data.aan_format = val.format;
      }
      data.aan_level = data.aan_level.replaceAll(val.from, val.to);
      data.aan_kpi_name = data.aan_kpi_name.replaceAll(val.from, val.to);
      data.inference = data.inference.replaceAll(val.from, val.to);
    });
  });
  /* remove below code if there is no masking */
  /* Also change aan_value_new to aan_value in below files */
  /* overallTrend.jsx - Line 11 */
  /* selectedTrend.jsx - Line 48 */
  /* rootcauseTable.jsx - Line 30 */
  masking.forEach(function (val) {
    rcas.data.forEach(function (data, i) {
      data.rc_kpi_name = data.rc_kpi_name.replaceAll(val.from, val.to);
      data.aan_kpi_name = data.aan_kpi_name.replaceAll(val.from, val.to);
      data.rc_value_new = data.rc_value_new.replaceAll(val.from, val.to);
      data.inference = data.inference.replaceAll(val.from, val.to);
    });
  });
  //console.log('RCA API', rcas);
  return rcas;
}
export async function getKpi(rc_level) {
  let rcas = await http.get(generateURL('kpi/' + rc_level));

    rcas.data.forEach(function (data) {
    data.aan_kpi_name = data.aan_name;
  });
    references.forEach(function (val) {
    rcas.data.forEach(function (data, i) {
     
      data.aan_name = data.aan_name.replaceAll(val.from, val.to);

    });
  });
  return rcas
}
//7. Get impacts by anomaly id
export async function getImpact(id) {
  let impacts = await http.get(generateURL('impact/' + id));
  references.forEach(function (val) {
    impacts.data.forEach(function (data, i) {
      data.inference = data.inference.replaceAll(val.from, val.to);
    });
  });
  /* remove below code if there is no masking */
  masking.forEach(function (val) {
    impacts.data.forEach(function (data, i) {
      data.inference = data.inference.replace(
        new RegExp('\\b' + val.from + '\\b', 'gi'),
        val.to
      );
    });
  });
  //console.log('Impact API', impacts);
  return impacts;
}

//6. Get RCAs by anomaly id
export async function getNetworkData(id) {
  let network = await http.get(networkEndPoint + '/' + id);
  references.forEach(function (val) {
    network.data.nodes.forEach(function (data, i) {
      data.KPIlabel = data.KPIlabel.replaceAll(val.from, val.to);
    });
  });
  /* remove below code if there is no masking */
  masking.forEach(function (val) {
    network.data.nodes.forEach(function (data, i) {
      data.Dimlabel = data.Dimlabel.replaceAll(val.from, val.to);
      data.KPIlabel = data.KPIlabel.replaceAll(val.from, val.to);
    });
  });
  //console.log('Network Graph API', network);
  return network;
}

//7. Get similar alerts
export async function getSimilarAlerts(id) {
  let alerts = await http.get(generateURL('similar/' + id));
  references.forEach(function (val) {
    alerts.data.forEach(function (data, i) {
      data.inference = data.inference.replaceAll(val.from, val.to);
    });
  });
  /* remove below code if there is no masking */
  masking.forEach(function (val) {
    alerts.data.forEach(function (data, i) {
      data.inference = data.inference.replace(
        new RegExp('\\b' + val.from + '\\b', 'gi'),
        val.to
      );
    });
  });
  //console.log('Similar Alerts API', alerts);
  return alerts;
}
export async function saveConversation(user_uuid, conversationHistory){
  const userid=user_uuid
  const message=conversationHistory[0]['message']
  const response=conversationHistory[0]['response']
  const requested_date=conversationHistory[0]['requested_date']
  const response_date=conversationHistory[0]['response_date']

  let body={
    user_uuid:userid,
    message:message,
    response:response,
    requested_date:requested_date,
    response_date:response_date
  }
  let data = await http.post(chatPoint,body
  )
  return data
}
export async function getConversation(userid)
{
  let history = await http.get(chatPoint +'/' + userid);

  return history
}